import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideHelperTagForm from '../containers/CareGuideHelperTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideHelperTagAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideHelperTagAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_helper_tag_route_add')} />
          <CareGuideHelperTagForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideHelperTagAddScreen;

Logger.log('silly', `CareGuideHelperTagAddScreen loaded.`);
